import { render, staticRenderFns } from "./NumberLabel.vue?vue&type=template&id=3f625af3&"
import script from "./NumberLabel.vue?vue&type=script&lang=js&"
export * from "./NumberLabel.vue?vue&type=script&lang=js&"
import style0 from "./NumberLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports